import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FeaturedCollections({ collections }) {
  if (!collections || collections.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <div className="flex items-end justify-between mb-12">
        <div>
          <div className="text-xs tracking-[0.3em] uppercase text-primary font-semibold mb-3">◦ Featured Collections</div>
          <h2 className="font-serif text-4xl lg:text-5xl tracking-tight">Curated, in small chapters.</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {collections.slice(0, 3).map((c, i) => (
          <Link
            key={c.id || c.slug}
            to={`/collections/${c.slug}`}
            data-testid={`collection-card-${c.slug}`}
            className={`group block relative overflow-hidden bg-card border border-border rounded-sm hover:-translate-y-1 transition-transform duration-300 ${i === 0 ? "md:col-span-2 md:row-span-1" : ""}`}
            style={{ transitionProperty: "transform" }}
          >
            <div className={`${i === 0 ? "aspect-[16/9]" : "aspect-[4/5]"} overflow-hidden bg-secondary`}>
              <img
                src={c.hero_image || c.products?.[0]?.images?.[0]}
                alt={c.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-[1.04]"
                style={{ transition: "transform 0.6s ease" }}
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/70 via-foreground/10 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 text-background">
              <div className="text-[10px] tracking-[0.25em] uppercase opacity-80 mb-2 font-semibold">◦ {c.products?.length || 0} pieces</div>
              <h3 className="font-serif text-2xl lg:text-3xl tracking-tight">{c.title}</h3>
              {c.subtitle && <p className="mt-2 text-sm opacity-80 leading-snug max-w-md line-clamp-2">{c.subtitle}</p>}
              <span className="mt-4 inline-flex items-center gap-1 text-xs tracking-[0.15em] uppercase font-semibold">
                Open the chapter <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
